import Layout from '../components/Layout';
import NotFoundPage from '../components/pages/NotFoundPage';
import notFoundQuery from '../groq/pages/notFound';
import { sanityClient } from '../lib/sanity.server';
import { MenuType } from '../types';

interface PageProps {
  data: {
    menus: MenuType;
  };
}

export default function Custom404({ data }: PageProps) {
  const { menus } = data;

  const seo = {
    title: '404 side ikke funnet',
    description: '',
  };

  return (
    <Layout defaultSEO={seo} menus={menus}>
      <NotFoundPage />
    </Layout>
  );
}

export async function getStaticProps() {
  const data = await sanityClient.fetch(notFoundQuery);
  if (!data) return { notFound: true };

  return {
    props: { data },
    revalidate: 1,
  };
}
